<mulo-centered-block-layout>
    <div class="content">
        <mulo-brand width="auto"></mulo-brand>
        <img ngSrc="assets/images/no_content_placeholder.svg" alt="" class="margin-lg" height="220" width="330" />
        <p [innerHtml]="'research.portal.unavailable' | translate | htmlSanitize"></p>
    </div>
</mulo-centered-block-layout>
